import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Provider, connect } from 'react-redux'
import 'focus-visible'

import moment from 'moment-timezone'
import services from 'services'
import config from 'config'
import { ModalRoot } from 'components/styled/modal/modal-root'
import { toggleNavigationMenu, removeMessage } from 'actions'
import { mapLanguageToMoment } from 'i18n'
// import './app.less' TODO: remove if not needed anymore
import 'bootstrap/dist/css/bootstrap.min.css'

import { AlertList } from 'components/styled/alert/alert-list'
import { AlertContextProvider } from 'components/styled/alert/context'
import {
  ALL_MARKETING_SERVICES,
  CookieContextProvider,
} from 'components/styled/cookie-consent/context'
import { AnalyticsService } from 'analytics/performance'
import ThemeProvider from './theme/ThemeProvider'
import hideLoadingWrapper from './utils/hide-loading-wrapper'
import LanguageListener from './components/language-listener/language-listener'
import { PopoverRoot } from 'components/styled/popover/popover-root'
import { Outlet } from 'react-router-dom'
import 'react-loading-skeleton/dist/skeleton.css'

export class AppComponent extends Component {
  constructor(props) {
    super(props)
    const { language, store } = props
    services.setStore(store)
    // Remove ordinal character from italian and spanish dates
    // (Doesn't work right if locale is set just once)
    moment.locale(mapLanguageToMoment(language))
    moment.locale(
      mapLanguageToMoment(language),
      language === 'it' || language === 'es' ? { ordinal: '%d' } : undefined
    )
    hideLoadingWrapper()
  }

  onClick() {
    const { dispatch, navigationMenu } = this.props
    if (navigationMenu) {
      dispatch(toggleNavigationMenu(navigationMenu))
    }
  }

  getClassName() {
    const { language } = this.props
    if (language === 'zh') {
      return 'font-china'
    }
    if (language === 'ja') {
      return 'font-japanese'
    }
    return ''
  }

  render() {
    const { store, children, language, dispatch, messages } =
      this.props
    const className = this.getClassName()
    const pathname = window.location.pathname
    const notAdminPathName =
      pathname &&
      !pathname.startsWith('/admin') &&
      !pathname.startsWith('/introductions')

    return (
      <div>
        <LanguageListener lang={language} />
        <Provider store={store}>
          <CookieContextProvider
            enabledAnalytics={[AnalyticsService.Amplitude]}
            enabledMarketing={ALL_MARKETING_SERVICES}
            disableCandidateAnalytics={
              notAdminPathName && config.DISABLE_CANDIDATE_ANALYTICS
            }
          >
            <ThemeProvider useGlobalStyle>
              <div onClick={() => this.onClick()} className={className}>
                <div>
                  <AlertContextProvider>
                    <div>{children}</div>
                    <Outlet />
                    {/* TODO move this to app content so that it will inherit correct theme? */}
                    <AlertList
                      messages={messages}
                      closeAfterTimeout
                      removeMessage={(messageId) =>
                        dispatch(removeMessage(messageId))
                      }
                    />
                  </AlertContextProvider>
                </div>
                <PopoverRoot />
                <ModalRoot />
              </div>
            </ThemeProvider>
          </CookieContextProvider>
        </Provider>
      </div>
    )
  }
}

AppComponent.propTypes = {
  store: PropTypes.shape({}).isRequired,
  language: PropTypes.string.isRequired,
  navigationMenu: PropTypes.string,
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
  messages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

AppComponent.defaultProps = {
  navigationMenu: null,
  children: null,
}

export default connect((state) => ({
  language: state.global.language,
  navigationMenu: state.global.navigationMenu,
  messages: state.global.messages,
}))(AppComponent)
